import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
export var triangleSize = '8px';
export var triangleOffset = '50px';
export var datePickerHoverColour = tokens.colors.neutral.background.hover;
export var datePickerBorderColour = tokens.colors.neutral.trim.default;
export var datePickerBackgroundColour = tokens.colors.neutral.background.default;
export var datePickerCellSize = '25px';
export var datePickerNavigationalArrowSideOffset = '10px';
export var datePickerNavigationalArrowTopOffset = '12px';
export var datePickerBorderRadius = tokens.borderRadius.mini;
export var domainIconClose = '';
export var domainIconTick = '';
export var domainIconNavigationalDownArrow = '';
export var domainIconNavigationalUpArrow = '';
export var domainIconNavigationalLeftArrow = '';
export var domainIconNavigationalRightArrow = '';
export var fontSmall = /*#__PURE__*/css(applyFont(tokens.typography.caption));
export var domainIcon = {
  name: "zf4cus",
  styles: "font-family:'Domain',sans-serif !important;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;"
};